import React from 'react';
import classNames from 'classnames';

import ProductCardContainer from 'components/Common/Card/ProductCard/ProductCardContainer/ProductCardContainer';
import ProductCardImage from 'components/Common/Card/ProductCard/ProductCardImage/ProductCardImage';
import ProductCardStickers from 'components/Common/Card/ProductCard/ProductCardStickers/ProductCardStickers';
import { Props as ProductCardLabelProps } from 'components/Common/Card/ProductCard/ProductCardLabel/ProductCardLabel';
import { formatBrand } from 'services/product/formatter';
import { DefaultCarouselProductType } from 'types/Carousel';

import styles from './ProductCarousel.module.scss';

export type Props = {
  classes?: CarouselProductClassesType;
  onClick?: () => void;
  product: DefaultCarouselProductType;
};

type CarouselProductClassesType = {
  shortLabel?: string;
  thumbnail?: string;
};

export default function ProductCarousel({
  classes,
  onClick,
  product: {
    commercialOperationSticker,
    metaMarque,
    shortLabel,
    url,
    visuelFace,
  },
}: Props): JSX.Element {
  function handleClick(): void {
    scrollTo(0, 0);
    onClick?.();
  }

  return (
    <ProductCardContainer
      linkTo={url}
      onClick={handleClick}
      className={styles.card}
    >
      <ProductCardImage images={[{ alt: shortLabel, src: visuelFace }]}>
        <ProductCardStickers
          opecoSticker={commercialOperationSticker}
          classes={{ sticker: styles.sticker }}
        />
      </ProductCardImage>
      <ProductCardLabel
        label={shortLabel}
        brand={metaMarque}
        className={classes?.shortLabel}
      />
    </ProductCardContainer>
  );
}

function ProductCardLabel({ label, brand, className }: ProductCardLabelProps) {
  return (
    <div className={classNames(styles.shortLabel, className)}>
      {brand ? `${formatBrand(brand)} - ${label}` : label}
    </div>
  );
}
